module.exports = __webpack_public_path__ + "img/clock@3x.17443793.png";